import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  "NSE FUT": { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  "NSE OPT": { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  "NSE EQU": { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  MCX: { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  "MCX OPT": { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  FOREX: { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  COMEX: { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  GLOBEX: { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
  CRYPTO: { edited: [], blocked: [], staticBlocked: [], preBlock: [], deleted: [] },
};

const scriptSettingsRequestSlice = createSlice({
  name: "scriptSettingsRequestSlice",
  initialState,
  reducers: {
    setBlockedScripts: (state, action) => {
      const { tab, blocked, previous, type } = action.payload;
      if (type === "add") {
        state[tab].blocked = [...state[tab].blocked, ...blocked];
      } else {
        state[tab].blocked = blocked || [];
      }
    },
    addAllMarketBlockedScript: (state, action) => {
      const { data } = action.payload;
      for (let key in data) {
        if (state[key]) {
          state[key].blocked = data[key] || [];
          state[key].preBlock = data[key] || [];
        }
      }
    },
    setContentBlockScript: (state, action) => {
      const { data } = action.payload;
      for (let key in data) {
        if (state[key]) {
          state[key].staticBlocked = data[key];
        }
      }
    },

    setEditData: (state, action) => {
      return {
        ...state,
        [action.payload.tab]: {
          ...state[action.payload.tab],
          blocked: state[action.payload.tab].blocked || [],
          edited: action.payload?.edited,
        },
      };
    },
    setDeletedScripts: (state, action) => {
      const { tab, deleted } = action.payload;
      state[tab].deleted = deleted || [];
    },
    removeBlockedAndEdited: (state, action) => {
      return { ...initialState };
    },
  },
});

export default scriptSettingsRequestSlice.reducer;

export const scriptSettingRequestSelector = (state) =>
  state.scriptSettingsRequestSlice;

export const {
  setBlockedScripts,
  setEditData,
  setDeletedScripts,
  removeBlockedAndEdited,
  addAllMarketBlockedScript,
  setContentBlockScript,
} = scriptSettingsRequestSlice.actions;
